
import { LogLevel } from '@azure/msal-browser';

const b2cPolicies_names = {
  signIn: 'B2C_1A_CustApp_signin',
  forgotPassword: 'B2C_1A_CustApp_PasswordReset',
  changePassword: 'B2C_1A_CustApp_ChangePassword',
  editProfile: 'B2C_1A_CustApp_ProfileEdit',
};

export const b2cPolicies = {
  names: {
      signIn: b2cPolicies_names.signIn,
      changePassword: b2cPolicies_names.changePassword,
      forgotPassword: b2cPolicies_names.forgotPassword,
      editProfile: b2cPolicies_names.editProfile,
  },
  authorities: {
      signIn: {
          authority: `https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.b2clogin.com/${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/${b2cPolicies_names.signIn}`,
      },
      changePassword: {
          authority: `https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.b2clogin.com/${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/${b2cPolicies_names.changePassword}`,
      },
      forgotPassword: {
          authority: `https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.b2clogin.com/${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/${b2cPolicies_names.forgotPassword}`,
      },
      editProfile: {
          authority: `https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.b2clogin.com/${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/${b2cPolicies_names.editProfile}`,
      },
  },
  authorityDomain: `${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.b2clogin.com`,
};

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_B2C_AUTH_CLIENTID,
    authority: b2cPolicies.authorities.signIn.authority, 
    knownAuthorities: [b2cPolicies.authorityDomain], 
    redirectUri: `${window.location.origin}/`, //`${window.location.origin}/redirect`,
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    // scopes: process.env.REACT_APP_B2C_AUTH_SCOPES.split(','),
    // validateAuthority: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    }
  },
};

export const protectedResources = {
  api: {
      baseEndPoint: process.env.REACT_APP_API_BASE_URL,
      scopes: {
          read: [`https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/${process.env.REACT_APP_API_CLIENT_ID}/bic.read`
          ],
      },
  },
  databridgeApi: {
    baseEndPoint: process.env.REACT_APP_API_BASE_URL,
    scopes: {
        read: [`https://${process.env.REACT_APP_B2C_AUTH_B2C_TENANT}.onmicrosoft.com/databridge-api/data.read`],
    },
  },
};

export const loginRequest = {
  scopes: [...protectedResources.api.scopes.read],
};

export const changePasswordRequest = {
  authority: b2cPolicies.authorities.changePassword.authority,
  scopes: [...protectedResources.api.scopes.read],
  // No prompt=login here on purpose. The B2C_1A_CustApp_ChangePassword journey skips its
  // sign-in step when the session's objectId claim is present, taking the user straight to
  // the Old/New password page. Forcing interactive auth would hide that session and bring
  // the redundant sign-in screen back.
};